module.exports = __webpack_public_path__ + "open-sans-latin-600.ec8b5713a6abb2cd33ec.eot";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-600.eot
// module id = ../../../../typeface-open-sans/files/open-sans-latin-600.eot
// module chunks = 1 3